import axios from '../axiosInstance';

export async function getVehicleTypes({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/VehicleTypes/getVehicleTypes', {
        params: { search, pageSize, lastId },
        signal,
    });
    return data; // { items, lastId, hasMore }
}
